
import * as storyblokRuntime$FS_N3M8Xjtx46aK0E7zVgZ5079rwNwLjQOb1MGOYCgk from '/codebuild/output/src3520219688/src/ark/node_modules/@nuxt/image/dist/runtime/providers/storyblok'
import * as awsAmplifyRuntime$YlthaWzq6oA1hJmaIFsOwZq2qbyAUWHYjPZtFVugO08 from '/codebuild/output/src3520219688/src/ark/node_modules/@nuxt/image/dist/runtime/providers/awsAmplify'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "awsAmplify",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['storyblok']: { provider: storyblokRuntime$FS_N3M8Xjtx46aK0E7zVgZ5079rwNwLjQOb1MGOYCgk, defaults: {"baseURL":"https://a.storyblok.com"} },
  ['awsAmplify']: { provider: awsAmplifyRuntime$YlthaWzq6oA1hJmaIFsOwZq2qbyAUWHYjPZtFVugO08, defaults: {} }
}
        